// Add this component to TestingSection to debug media issues
// Put it right after your main return statement starts

import React, { useState, useEffect } from 'react';

export function MediaDebugInfo() {
  const [devices, setDevices] = useState({ audio: [], video: [] });
  const [permissions, setPermissions] = useState({ camera: 'unknown', microphone: 'unknown' });

  useEffect(() => {
    // Check available devices
    const checkDevices = async () => {
      try {
        const allDevices = await navigator.mediaDevices.enumerateDevices();
        const audioDevices = allDevices.filter(d => d.kind === 'audioinput');
        const videoDevices = allDevices.filter(d => d.kind === 'videoinput');
        
        console.log('[DEBUG] Audio devices:', audioDevices.length);
        console.log('[DEBUG] Video devices:', videoDevices.length);
        
        setDevices({ audio: audioDevices, video: videoDevices });
      } catch (err) {
        console.error('[DEBUG] Error enumerating devices:', err);
      }
    };

    // Check permissions
    const checkPermissions = async () => {
      try {
        const cameraResult = await navigator.permissions.query({ name: 'camera' });
        const micResult = await navigator.permissions.query({ name: 'microphone' });
        
        console.log('[DEBUG] Camera permission:', cameraResult.state);
        console.log('[DEBUG] Microphone permission:', micResult.state);
        
        setPermissions({
          camera: cameraResult.state,
          microphone: micResult.state
        });

        // Listen for permission changes
        cameraResult.onchange = () => {
          console.log('[DEBUG] Camera permission changed to:', cameraResult.state);
          setPermissions(prev => ({ ...prev, camera: cameraResult.state }));
        };
        
        micResult.onchange = () => {
          console.log('[DEBUG] Microphone permission changed to:', micResult.state);
          setPermissions(prev => ({ ...prev, microphone: micResult.state }));
        };
      } catch (err) {
        console.warn('[DEBUG] Permissions API not supported or error:', err);
      }
    };

    checkDevices();
    checkPermissions();

    // Re-check devices every 2 seconds
    const interval = setInterval(checkDevices, 2000);
    return () => clearInterval(interval);
  }, []);

  // Only show in development
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      left: '10px',
      background: 'rgba(0,0,0,0.8)',
      color: 'white',
      padding: '10px',
      borderRadius: '5px',
      fontSize: '11px',
      fontFamily: 'monospace',
      zIndex: 9999,
      maxWidth: '300px'
    }}>
      <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>🔍 Media Debug Info</div>
      
      <div style={{ marginBottom: '6px' }}>
        <strong>Camera:</strong> {permissions.camera}
        <br />
        <span style={{ color: permissions.camera === 'granted' ? '#4ade80' : '#ef4444' }}>
          {devices.video.length} device(s) found
        </span>
      </div>
      
      <div style={{ marginBottom: '6px' }}>
        <strong>Microphone:</strong> {permissions.microphone}
        <br />
        <span style={{ color: permissions.microphone === 'granted' ? '#4ade80' : '#ef4444' }}>
          {devices.audio.length} device(s) found
        </span>
      </div>

      <div style={{ fontSize: '9px', marginTop: '8px', opacity: 0.7 }}>
        User Agent: {navigator.userAgent.includes('AIEvaluatorDesktop') ? '✅ Desktop App' : '❌ Browser'}
      </div>
    </div>
  );
}

// Add this to your TestingSection component:
// return (
//   <div className="system-check-page">
//     <MediaDebugInfo />
//     {/* rest of your JSX */}
//   </div>
// );